import { defineMessages } from 'react-intl';

export const actionsMessages = defineMessages({
    actions: {
        id: 'actions',
        defaultMessage: 'Actions',
    },
    lprDetection: {
        id: 'lpr-detection',
        defaultMessage: 'LPR Detection',
    },
    lprDetectionDescription: {
        id: 'lpr-detection-description',
        defaultMessage: 'Create a new LPR detection',
    },
    lpr: {
        id: 'lpr',
        defaultMessage: 'LPR',
    },
    lprSectionDescription: {
        id: 'lpr-section-description',
        defaultMessage: 'Actions for LPR cameras',
    },
    createLprDetection: {
        id: 'create-lpr-detection',
        defaultMessage: 'Create LPR detection',
    },
    point: {
        id: 'point',
        defaultMessage: 'Point',
    },
    identifierType: {
        id: 'identifier-type',
        defaultMessage: 'Identifier type',
    },
    identifier: {
        id: 'identifier',
        defaultMessage: 'Identifier',
    },
    clickToUpload: {
        id: 'click-to-upload',
        defaultMessage: 'Click to upload',
    },
    images: {
        id: 'images',
        defaultMessage: 'Images',
    },
    createdLPRdetection: {
        id: 'created-lpr-detection',
        defaultMessage: 'LPR detection created',
    },
    createdLPRdetectionDescription: {
        id: 'created-lpr-detection-description',
        defaultMessage: 'LPR detection has been successfully created.',
    },
    selectDate: {
        id: 'select-date',
        defaultMessage: 'Select a date',
    },
});
